import { useMessage } from '~/composables/common/useMessage';
import { ApiError } from '~/error/base/ApiError';
import { ClientError } from '~/error/ClientError';
import { MessageCodeEnum } from '~/constants/MessageCode';
import { isPublicPath } from '~/constants/publicPaths';

export default defineNuxtRouteMiddleware(async (to) => {
  const logger = useLogger('0-00');

  // 認証不要のパスは処理をスキップ
  if (isPublicPath(to.path)) {
    return;
  }

  // パスワード変更必須のユーザから要認証画面にアクセスされた場合はログイン画面にリダイレクト
  const loginUserStore = useLoginUserStore();
  if (loginUserStore.loginUser?.mustChangePassword) {
    logger.warn('パスワード変更が必要なユーザがアクセスしました。ログイン画面にリダイレクトします。');
    return navigateTo('/login');
  }

  // 認証チェック
  const { checkAuth } = useAuth('0-00');
  let isAuthenticated = false;
  try {
    isAuthenticated = await checkAuth();
  }
  catch (error) {
    // ミドルウェアで発生した例外はグローバルエラーハンドラで捕捉できないため個別にハンドリング
    const { showClientMessage, showApiMessage } = useMessage();
    const logger = useLogger('0-00');
    if (error instanceof ClientError) {
      logger.error('ミドルウェアでエラー発生', error);
      showClientMessage(error.displayId, error.messageCode);
    }
    else if (error instanceof ApiError) {
      logger.error('ミドルウェアでAPIエラー発生', error);
      showApiMessage(error.displayId, error.status, error.message);
    }
    else {
      logger.error('ミドルウェアでその他エラー発生', error as Error);
      showClientMessage('0-00', MessageCodeEnum.UNKNOWN_ERROR);
    }
    return false;
  }

  if (!isAuthenticated) {
    logger.warn('認証に失敗しました。ログイン画面にリダイレクトします。');
    return navigateTo('/login');
  }
});
